import { render, staticRenderFns } from "./EventChat.vue?vue&type=template&id=65ba8d0a&scoped=true"
import script from "./EventChat.vue?vue&type=script&lang=js"
export * from "./EventChat.vue?vue&type=script&lang=js"
import style0 from "./EventChat.vue?vue&type=style&index=0&id=65ba8d0a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ba8d0a",
  null
  
)

export default component.exports